import { Link } from "react-router-dom";
import { Clock, Phone, Mail, MapPin } from "lucide-react";
import WhatsAppIcon from "@/components/WhatsAppIcon";

const PHONE_E164 = "+263776162659";
const WHATSAPP_LINK = "https://wa.me/263776162659";

export default function Footer() {
  return (
    <footer className="border-t border-[#E5E2DE] bg-[#1A1523] text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <div className="mb-4 font-heading text-2xl font-bold text-white">
              Joseph <span className="text-[#E87722]">Roberts</span> Capital
            </div>
            <p className="text-sm leading-relaxed text-white/70">
              A Zimbabwean microfinance company empowering individuals, civil servants and
              businesses with flexible, dignified financial solutions.
            </p>
          </div>
          <div>
            <div className="mb-4 text-xs font-semibold uppercase tracking-[0.15em] text-[#E87722]">Products</div>
            <ul className="space-y-2 text-sm text-white/80">
              <li><Link to="/products" className="hover:text-[#E87722]">Civil Servant Loans</Link></li>
              <li><Link to="/products" className="hover:text-[#E87722]">Salary-Based Loans</Link></li>
              <li><Link to="/products" className="hover:text-[#E87722]">Business Loans</Link></li>
              <li><Link to="/products" className="hover:text-[#E87722]">Agricultural Loans</Link></li>
              <li><Link to="/products" className="hover:text-[#E87722]">Asset Finance</Link></li>
            </ul>
          </div>
          <div>
            <div className="mb-4 text-xs font-semibold uppercase tracking-[0.15em] text-[#E87722]">Company</div>
            <ul className="space-y-2 text-sm text-white/80">
              <li><Link to="/about" className="hover:text-[#E87722]">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-[#E87722]">Contact</Link></li>
              <li><Link to="/apply" className="hover:text-[#E87722]">Apply for a Loan</Link></li>
              <li><Link to="/login" className="hover:text-[#E87722]">Client Login</Link></li>
            </ul>
          </div>
          <div>
            <div className="mb-4 text-xs font-semibold uppercase tracking-[0.15em] text-[#E87722]">Reach Us</div>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 text-[#E87722]" /> 1 Harvey Brown Ave, Milton Park, Harare, Zimbabwe</li>
              <li className="flex items-start gap-2">
                <Phone className="mt-0.5 h-4 w-4 text-[#E87722]" />
                <a href={`tel:${PHONE_E164}`} className="hover:text-[#E87722]" data-testid="footer-phone">{PHONE_E164}</a>
              </li>
              <li className="flex items-start gap-2">
                <WhatsAppIcon className="mt-0.5 h-4 w-4 text-[#E87722]" />
                <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer" className="hover:text-[#E87722]" data-testid="footer-whatsapp">
                  Chat on WhatsApp
                </a>
              </li>
              <li className="flex items-start gap-2"><Mail className="mt-0.5 h-4 w-4 text-[#E87722]" /> <span>applications@josephrobertscapital.com<br />info@josephrobertscapital.com</span></li>
              <li className="flex items-start gap-2">
                <Clock className="mt-0.5 h-4 w-4 text-[#E87722]" />
                <span>
                  Mon–Fri · 08:00–17:00<br />
                  Sat · 08:00–13:00<br />
                  <span className="text-white/50">Closed Sundays & bank holidays</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 flex flex-col gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-white/50">© {new Date().getFullYear()} Joseph Roberts Capital. All rights reserved.</p>
          <p className="text-xs text-white/50">Registered Microfinance Institution — Zimbabwe</p>
        </div>
      </div>
    </footer>
  );
}
